/* unplugin-vue-components disabled */import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.waterMark.show ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle($options.styles)
  }, null, 4 /* STYLE */)) : _createCommentVNode("v-if", true);
}